import React, { PropTypes } from 'react';
import classNames from 'classnames';

import {quote, unorderedList, orderedList} from './ButtonSvgs'

const SingleButtonBlock = (props) => {
    const button = ()=> {
        switch ( props.label ) {
            case "Bullet list":
                return unorderedList;
            case "Ordered list":
                return orderedList;
            case "Quote":
                return quote;
            default:
                return props.label
        }
    };


    const onToggle = (e) =>{
        e.preventDefault();
        if(!props.disabled) {
            console.log(props.value)
            props.onToggle(props.value);
        }
    };

    const className = classNames({
       "richutils__button" : true,
        "-active" : props.active,
        "-inactive" :props.disabled

    });

    return (
    <div className={className} onMouseDown={onToggle}>
        <div className="richutils__svg-wrapper">
            {button()}
        </div>
        <div className="rich-button__label">
            {props.label}
            <div className="rich-button__arrow"></div>
        </div>
    </div>
    )
};

SingleButtonBlock.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool
};

export default SingleButtonBlock;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/SingleButtonBlock.js